import Vue from "vue";
import App from "./App";
import router from "./router";
import { Messenger } from "./assets/script/message";
import store from "./store";
import "./assets/style/index.less";
import Switch from "./components/form/Switch";
import { LoginBox } from "./components/global/LoginBox";
import { LoginBox2 } from "./components/global/LoginBox2";
import Chart from "./components/Chart";
import Chart2 from "./components/Chart2";
import directive from "./assets/script/directive";
Vue.component("v-switch", Switch);
Vue.component("v-chart", Chart);
Vue.component("v-chart-2", Chart2);
Vue.config.productionTip = false;

Vue.directive("loading", directive.loading);

Vue.prototype.$messenger = new Messenger(
  "_5118_iframe_List_Info",
  "MessengerProject"
);
Vue.prototype.$messengernew = new Messenger(
  "_5118_iframe_popup",
  "MessengerProject"
);
Vue.prototype.$messengerpm = new Messenger(
  "_5118_iframe_Pm_popup",
  "MessengerProject"
);
Vue.prototype.$wycmessenger = new Messenger(
  "_5118_wyc_iframe_Info",
  "MessengerProject"
);
Vue.prototype.$bddiffmessageer = new Messenger(
  "_5118_iframe_Baidu_Top_Info",
  "MessengerProject"
);
Vue.prototype.$bdseorankmessageer = new Messenger(
  "_5118_baidu_rank_seo_list",
  "MessengerProject"
);
Vue.prototype.$showboxmessage = new Messenger(
  "_5118_cmsshowboxiframe",
  "MessengerProject"
);
Vue.prototype.$icpinfo = new Messenger(
  "_5118_baidu_rank_icp_list",
  "MessengerProject"
);
Vue.prototype.theversion = "2.0.1";

Vue.prototype.$loginBox = LoginBox;
Vue.prototype.$loginBox2 = LoginBox2;

Vue.prototype.$open = function(url) {
  window.open(url);
};

Vue.prototype.$geticpurl = "https://icp.5118.com";

String.prototype.encodeUnicode = function() {
  let str = this;
  let res = [];
  for (let i = 0; i < str.length; i++) {
    res[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4);
  }
  res = "\\u" + res.join("\\u");
  return res
    .replace(/\\u00/g, "l")
    .replace(/\\u/g, "")
    .split("")
    .reverse()
    .join("");
};

Array.prototype.first = function() {
  return this[0];
};
Array.prototype.last = function() {
  return this[this.length - 1];
};

Object.defineProperty(Object.prototype, "isEmptyObject", {
  value: function(obj) {
    return !Object.keys(obj).length;
  }
});

function encodeUnicode(str) {
  var res = [];
  for (var i = 0; i < str.length; i++) {
    res[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4);
  }
  return "\\u" + res.join("\\u");
}

String.prototype.encodeUnicode = function() {
  return encodeUnicode(this)
    .replace(/\\u00/g, "l")
    .replace(/\\u/g, "")
    .split("")
    .reverse()
    .join("");
};

Number.prototype.encodeUnicode = function() {
  return encodeUnicode(this.toString())
    .replace(/\\u00/g, "l")
    .replace(/\\u/g, "")
    .split("")
    .reverse()
    .join("");
};

window.$vue = new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js